module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./AgreementsView.js"));
	}, "AgentContractView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AgentContractView!./src/pages/Shop/Member/Agreements/AgreementsView.js
// module id = 1441
// module chunks = 418